import { PaletteMode, useTheme } from '@mui/material';

const filterPaperElevationMap: Record<PaletteMode, Record<number, number>> = {
  dark: { 0: 0, 1: 2, 2: 6, 3: 12, 4: 16, 5: 18, 6: 20, 7: 22, 8: 24 },
  light: { 0: 1, 1: 2, 2: 3, 3: 4, 4: 5, 5: 6, 6: 7, 7: 8, 8: 9 },
};

export const useFilterPaperElevation = (nestingLevel: number) => {
  const { palette } = useTheme();
  const elevationMap = filterPaperElevationMap[palette.mode];
  return nestingLevel in elevationMap ? elevationMap[nestingLevel] : nestingLevel;
};
